import Slider from 'react-slick';
import '../../styles/home-testimonials.css';
import { FaArrowRight } from 'react-icons/fa';
import { usePrefersReducedMotion } from '../../hooks/usePrefersReducedMotion';
import { slickDotPaging } from '../../utils/slickAccessibleDots';

const TESTIMONIALS = [
  {
    id: 'richard-d',
    quote:
      'Kailash has worked with me on various projects and has always exceeded my expectations. Work always completed in a timely manner. Professional work, and very communicative. I highly recommend Kailash for your future project work.',
    name: 'Richard D.',
    company: 'Tipster Challenge',
    initials: 'RD',
  },
  {
    id: 'mayank-kumar',
    quote:
      'Kailash has demonstrated extraordinary brilliance while working with eVanik Networks. His knack for understanding the problem and solving it with out of the box thinking is what is really expected out of great engineers. I wish him all the best in his future endeavours.',
    name: 'Mayank Kumar',
    company: 'eVanik Networks',
    initials: 'MK',
  },
];

export default function HomeClientVoices() {
  const reduceMotion = usePrefersReducedMotion();
  const sliderSettings = {
    dots: true,
    customPaging: slickDotPaging('Go to testimonial'),
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: !reduceMotion,
    autoplaySpeed: 9000,
    pauseOnHover: true,
  };

  return (
    <section className="home-client-voices home-surface--light" aria-labelledby="home-client-voices-heading">
      <div className="home-client-voices__shell">
        <div className="home-client-voices__header">
          <div>
            <p className="home-focus-section__kicker">Client proof</p>
            <h2 id="home-client-voices-heading" className="h2 heading-title">
              What clients say about working with us
            </h2>
            <p className="heading-text">
              Feedback from teams that trusted us with production websites, ecommerce systems, and platform delivery.
            </p>
          </div>
          <div className="home-client-voices__signal" aria-hidden="true">
            <span>Scope</span>
            <FaArrowRight />
            <span>Delivery</span>
            <FaArrowRight />
            <span>Trust</span>
          </div>
        </div>

        <div className="home-client-voices__panel">
          <Slider
            className="home-client-voices__slider"
            {...sliderSettings}
          >
            {TESTIMONIALS.map((item) => (
              <div key={item.id}>
                <figure className="home-client-voices__slide">
                  <blockquote className="home-client-voices__quote">
                    <p>{item.quote}</p>
                  </blockquote>
                  <figcaption className="home-client-voices__author">
                    <span className="home-client-voices__avatar" aria-hidden="true">
                      {item.initials}
                    </span>
                    <span className="home-client-voices__meta">
                      <cite>{item.name}</cite>
                      <span>{item.company}</span>
                    </span>
                  </figcaption>
                </figure>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
